import { render, staticRenderFns } from "./LongestStreak.vue?vue&type=template&id=55a422d9&scoped=true&"
import script from "./LongestStreak.vue?vue&type=script&lang=js&"
export * from "./LongestStreak.vue?vue&type=script&lang=js&"
import style0 from "./LongestStreak.vue?vue&type=style&index=0&id=55a422d9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a422d9",
  null
  
)

export default component.exports